import { render, staticRenderFns } from "./CollectionLayoutTilesTile.vue?vue&type=template&id=f541ed5a&lang=pug&"
import script from "./CollectionLayoutTilesTile.vue?vue&type=script&lang=js&"
export * from "./CollectionLayoutTilesTile.vue?vue&type=script&lang=js&"
import style0 from "./CollectionLayoutTilesTile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f541ed5a')) {
      api.createRecord('f541ed5a', component.options)
    } else {
      api.reload('f541ed5a', component.options)
    }
    module.hot.accept("./CollectionLayoutTilesTile.vue?vue&type=template&id=f541ed5a&lang=pug&", function () {
      api.rerender('f541ed5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/CollectionLayoutTilesTile.vue"
export default component.exports